<template>
    <div class="d-md-flex w-100 align-items-center justify-content-md-start px-1">
        <div class="title multiline" :class="optional_title_class" v-if="title">{{ title }}</div>
        <div class="content flex-grow-1 d-grid gap-2" :class="optional_text_class">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SummaryBox',
    props: {
        // <summary-box :title="'申込内容\n申込内容'"> ← 改行の指定方法
        title: {
            type: String,
            default: ''
        },
        icon: {
            type: String,
            default: 'bi-gear-fill'
        },
        optional_title_class: {
            type: String,
            default: ''
        },
        optional_text_class: {
            type: String,
            default: ''
        },
        backTo: {
            type: Object,
            default: () => {
                return { name: null };
            }
        },
    }
}
</script>

<style scoped>
    section {font-size: 1.08rem;}
    .title {color: #666; background: #dfdfdf; border-radius: 5px; text-align: center; line-height: 1.1rem; padding: .6rem; margin-bottom: .5rem; }
    .content {margin-bottom: 1rem;}
    @media (min-width: 768px) {
        .title {color: #666; background: #dfdfdf; text-align: center; font-size: .9rem; line-height: 1.1rem; padding: 1.4rem 0; width: 110px; min-width: 110px; height: 110px; border-radius: 50%; display: flex; justify-content: center; align-items: center; flex-wrap: wrap; margin: .2rem .7rem;}
        .content {margin-bottom: 0;}
    }
</style>
